$(document).ready(function () {

  resizeContact();

  $(window).resize(function () {

    resizeContact();

  });
});

function resizeContact() {
  var max = -1;
  $('.contact-block-wrapper').find('.content-center').each(
    function () {
      if ($(this).outerHeight() > max) {
        max = $(this).outerHeight();
      }
    }
  );
  $('.contact-block-wrapper').each(
    function () {
      $(this).css('height', max + 'px');
    }
  );
}